import React, { useState } from 'react';
import {
    Box, Select, Typography, FormControlLabel, Autocomplete, Checkbox, Card,
    FormControl, FormHelperText, TextField, Stack, MenuItem,
    InputAdornment
} from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import ShowComponents from '../Common/ShowComponent';
import { renderTitle, ActionButton } from './SarasCommonComp';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { LocalizationProvider, DatePicker, DateTimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DateTime } from 'luxon'
import { calculateBMI, calculateWeeksAndDays, calculateBSA } from '../../../../Components/CommonFunctions/CommonFunctions';
import { qDoctorAppointmentId } from '../../../../Utility/Services/DoctorPatientQueryIds';
import Grid from '@mui/material/Grid';
import dayjs from 'dayjs';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import { oxygen_source_list } from "../../../../Utility/Constants";
import { getClinicIdWithContext, getSpecializationIdWithContext, localGetItem } from '../../../../Utility/Services/CacheProviderService';


const SarasVitals = ({ Title, ...props }) => {
    const [loading, setLoading] = useState(false);
    const [postLoading, setPostLoading] = useState(false);
    const [vitalLayout, setVitalLayout] = useState([]);
    const [nurseList, setNurseList] = useState(null);
    const [vitalState, setVitalState] = useState({
        selectedId: null,
        height_cm: "",
        weight_kg: "",
        blood_pressure_diastolic: "",
        blood_pressure_systolic: "",
        temperature: "",
        tempUnit: 'F',
        pulse_oximetry: "",
        pulse_rate: "",
        blood_sugar: "",
        temperature_unit: "",
        bmi: "",
        bsa: "",
        expected_date_of_delivery: "",
        gestational_weeks: "",
        gestational_days: "",
        DeliverydateCalac: false,
        GestationalCalculation: false,
        obs_LastMenstrualPeriod: null,
        oxygen_source: "",
        oxygen_support: "",

        gestational_age_weeks: "",
        gestational_age_days: "",
        head_circumference: "",
        waist_circumference: "",
        vitalDate: new Date(),
        comments: "",
        nurse_name: null,
        corrected_edd: null,
        heartRate: "",
        respiratoryRate: "",
        capillaryRefillTime: "",
    });

    const getApiCall = () => {
        getDoctorNotesVitalData()
        getNurseList()
        getVitalLayoutConfigData()
    }

    const getDoctorNotesVitalData = async () => {
        try {
            setLoading(true);
            const response = await RestAPIService.getAll(`${Serviceurls.SARAS_DOC_VITALS}?appointment_id=${qDoctorAppointmentId(props?.appointmentId)}`);
            if (response?.data?.status === 'success') {
                const data = (response?.data?.data && Object.keys(response?.data?.data)?.length > 0) ? response.data.data : {};
                setVitalState({
                    selectedId: data?.id || null,
                    height_cm: data?.height_cm || "",
                    weight_kg: data?.weight_kg || "",
                    blood_pressure_diastolic: data?.blood_pressure_diastolic || "",
                    blood_pressure_systolic: data?.blood_pressure_systolic || "",
                    temperature: data?.temperature || "",
                    pulse_oximetry: data?.pulse_oximetry || "",
                    pulse_rate: data?.pulse_rate || "",
                    blood_sugar: data?.blood_sugar || "",
                    tempUnit: data?.temperature_unit || "F",
                    bmi: data?.bmi || "",
                    bsa: data?.bsa || "",
                    expected_date_of_delivery: data?.expected_date_of_delivery || null,
                    obs_LastMenstrualPeriod: data?.last_menstrual_period || null,
                    gestational_age_days: !!(data?.gestational_age_weeks || data?.gestational_age_days),
                    gestational_age_weeks: data?.gestational_age_weeks || "",
                    gestational_age_days: data?.gestational_age_days || "",
                    head_circumference: data?.head_circumference || "",
                    waist_circumference: data?.waist_circumference || "",
                    vital_entered_time: data?.vital_entered_time || new Date(),
                    comments: data?.comments || "",
                    nurse_name: (data?.nurse_name && data?.nurse_profile_id)
                        ? { nurse: data?.nurse_name, staff_id: data?.nurse_profile_id }
                        : null,
                    DeliverydateCalac: data?.expected_date_of_delivery ? true : false,
                    GestationalCalculation: (data?.gestational_age_weeks || data?.gestational_age_days) ? true : false,
                    oxygen_source: data?.oxygen_source || "",
                    oxygen_support: data?.oxygen_support || "",
                    corrected_edd: data?.corrected_edd || null,
                    heartRate: data?.heart_rate || "",
                    respiratoryRate: data?.respiratory_rate || "",
                    capillaryRefillTime: data?.capillary_refill_time || "",
                });
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            props.errorMessage(error?.response?.data?.message || error.message);
        }
    }


    const getVitalLayoutConfigData = () => {
        try {
            const { PatientData, clinicId } = props
            const specialization_id = PatientData?.speciality_id ?? PatientData?.specialization_id ?? PatientData?.doctor_speciality ?? getSpecializationIdWithContext();
            RestAPIService.getAll(`${Serviceurls.VITALS_CONFIGURATION}?specialization_id=${specialization_id}&clinic_id=${clinicId}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        const right_Fields_data = response?.data?.data?.[0]?.vital_layout_data || [];
                        setVitalLayout(right_Fields_data)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })

        } catch (e) {
            props.errorMessage(e?.message)
        }
    }


    const getNurseList = () => {
        try {
            const clinicID = localGetItem('SelectedDoctorClinicId') ? JSON.parse(localGetItem('SelectedDoctorClinicId')) : null;
            // const clinicID = getCachevalue("SelectedDoctorClinic") ? JSON.parse(getCachevalue("SelectedDoctorClinic")) : null;
            RestAPIService.getAll(Serviceurls.FO_STAFF_LIST + `?clinic_id=${clinicID ?? getClinicIdWithContext()}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        setNurseList(response.data.data)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            props.errorMessage(error.message)
        }
    }

    const onClearHandler = () => {
        setVitalState({
            height_cm: "",
            weight_kg: "",
            blood_pressure_diastolic: "",
            blood_pressure_systolic: "",
            temperature: "",
            pulse_oximetry: "",
            pulse_rate: "",
            blood_sugar: "",
            temperature_unit: "",
            bmi: "",
            bsa: "",
            expected_date_of_delivery: null,
            DeliverydateCalac: false,
            GestationalCalculation: false,
            obs_LastMenstrualPeriod: null,
            gestational_age_weeks: "",
            gestational_age_days: "",
            head_circumference: "",
            waist_circumference: "",
            vitalDate: new Date(),
            comments: "",
            nurse_name: null,
            oxygen_source: "",
            oxygen_support: "",
            corrected_edd: null,
            heartRate:'',
            respiratoryRate:'',
            capillaryRefillTime:''
        });
    };
    const postDoctorNotesVitalData = async () => {
        try {
            const states = vitalState;
            const date = DateTime.fromJSDate(states.vitalDate ? new Date(states.vitalDate) : new Date()).toFormat("yyyy-MM-dd hh:mm:ss a");

            const data = {
                id: states.selectedId || null,
                appointment_id: props.appointmentId,
                blood_pressure_diastolic: +states.blood_pressure_diastolic,
                blood_pressure_systolic: +states.blood_pressure_systolic,
                blood_sugar: +states.blood_sugar,
                bmi: states.height_cm && states.weight_kg ? states.bmi : null,
                bsa: states.height_cm && states.weight_kg ? states.bsa : null,
                height_cm: +states.height_cm,
                pulse_rate: +states.pulse_rate,
                pulse_oximetry: +states.pulse_oximetry,
                temperature: +states.temperature,
                temperature_unit: states.tempUnit || "F",
                weight_kg: +states.weight_kg,
                dataDisable: true,
                head_circumference: states.head_circumference ? +states.head_circumference : null,
                waist_circumference: states.waist_circumference || null,
                gestational_age_days: states.gestational_age_days || "",
                gestational_age_weeks: states.gestational_age_weeks || "",
                last_menstrual_period: states.obs_LastMenstrualPeriod ? DateTime.fromJSDate(new Date(states.obs_LastMenstrualPeriod)).toFormat("yyyy-MM-dd") : null,
                expected_date_of_delivery: states.expected_date_of_delivery ? DateTime.fromJSDate(new Date(states.expected_date_of_delivery)).toFormat("yyyy-MM-dd") : null,
                comments: states.comments || "",
                nurse_profile_id: states.nurse_name === null ? "" : states.nurse_name.staff_id,
                vital_entered_time: date,
                oxygen_source: states.oxygen_source || "",
                oxygen_support: states.oxygen_support || "",
                corrected_edd: states.corrected_edd ?  DateTime.fromJSDate(new Date(states.corrected_edd)).toFormat("yyyy-MM-dd") : null,
                heart_rate:Number(states.heartRate) || null,
                respiratory_rate:Number(states.respiratoryRate) || null,
                capillary_refill_time:states.capillaryRefillTime || null
            };

            const hasAnyValue = Object.values({
                height_cm: states.height_cm,
                weight_kg: states.weight_kg,
                blood_pressure_systolic: states.blood_pressure_systolic,
                blood_pressure_diastolic: states.blood_pressure_diastolic,
                temperature: states.temperature,
                pulse_oximetry: states.pulse_oximetry,
                waist_circumference: states.waist_circumference,
                blood_sugar: states.blood_sugar,
                pulse_rate: states.pulse_rate,
                head_circumference: states.head_circumference,
                gestational_age_days: states.gestational_age_days,
                gestational_age_weeks: states.gestational_age_weeks,
                obs_LastMenstrualPeriod: states.obs_LastMenstrualPeriod,
                expected_date_of_delivery: states.expected_date_of_delivery,
                comments: states.comments,
                nurse_name: states.nurse_name,
                corrected_edd: states.corrected_edd,
                heart_rate:Number(states.heartRate),
                respiratory_rate:Number(states.respiratoryRate),
                capillary_refill_time:states.capillaryRefillTime
            }).some(value => value !== "" && value !== null);

            if (hasAnyValue) {
                setPostLoading(true);
                try {
                    const response = await RestAPIService.create(data, Serviceurls.SARAS_DOC_VITALS);
                    if (response?.data?.status === 'success') {
                        setPostLoading(false);
                        props.successMessage(response.data.message);
                        getDoctorNotesVitalData();
                        onClearHandler();
                    }
                } catch (error) {
                    setPostLoading(false);
                    props.errorMessage(error?.response?.data?.message || error.message);
                }
            } else {
                setPostLoading(false);
                props.errorMessage('Enter at least one data');
            }
        } catch (error) {
            setPostLoading(false);
            props.errorMessage(error.message);
        }
    };
    const bmiHelperText = (bmi) => {
        try {
            let message = null
            if (bmi <= 18.5) {
                message = 'Mild Thinness'
            } else if (bmi > 18.5 && bmi <= 25) {
                message = 'Normal'
            } else if (bmi > 25 && bmi <= 30) {
                message = 'Overweight'
            } else if (bmi > 30) {
                message = 'Obesity'
            }
            return message;
        } catch (error) {
            props.errorMessage(error.message)
        }
    }
    const bsaHelperText = (bsa) => {
        try {
            let message = null
            if (bsa < 1.4) {
                message = 'Below Normal'
            } else if (bsa >= 1.4 && bsa <= 2.4) {
                message = 'Normal Range'
            } else if (bsa > 2.4) {
                message = 'Above Normal'
            }
            return message;
        } catch (error) {
            props.errorMessage(error.message)
        }
    }
    const onChangeHandler = (e, key) => {
        try {
            let value = e.target.value;
            let num = CommonValidation.DecimalNumber(value);
            let isOnlyNum = CommonValidation.numberOnly(value);
            setVitalState((prev) => {
                const updatedState = { ...prev };

                switch (key) {
                    case "height_cm":
                        if ((num && value >= 1 && value <= 230) || value === "") {
                            updatedState.height_cm = value;
                            const bmi = calculateBMI(prev.weight_kg, value);
                            const bsa = calculateBSA(value, prev.weight_kg);                         
                            updatedState.bmi = bmi?.toFixed(2);
                            updatedState.bsa = bsa?.toFixed(2);
                        }
                        break;
                    case "weight_kg":
                        if ((num && value >= 1 && value <= 500) || value === "") {
                            updatedState.weight_kg = value;
                            const bmi = calculateBMI(value, prev.height_cm);
                            const bsa = calculateBSA(prev.height_cm, value)                          
                            updatedState.bmi = bmi?.toFixed(2);
                            updatedState.bsa = bsa?.toFixed(2);
                        }
                        break;
                    case "heartRate":
                        if ((num && value >= 1 && value <= 250) || value === "") {
                            updatedState.heartRate = value;
                        }
                        break;

                    case "respiratoryRate":
                        if ((num && value >= 1 && value <= 80) || value === "") {
                            updatedState.respiratoryRate = value;
                        }
                        break;

                    case "capillaryRefillTime":
                        updatedState.capillaryRefillTime = value;
                        break;
                    case "blood_pressure_diastolic":
                        if ((num && value >= 1 && value <= 200) || value === "") {
                            updatedState.blood_pressure_diastolic = value;
                        }
                        break;
                    case "blood_pressure_systolic":
                        if ((num && value >= 1 && value <= 250) || value === "") {
                            updatedState.blood_pressure_systolic = value;
                        }
                        break;
                    case "temperature":
                        if ((prev.tempUnit === "F" && num && value >= 1 && value <= 248) ||
                            (prev.tempUnit === "C" && num && value >= 1 && value <= 200) ||
                            value === "") {
                            updatedState.temperature = value;
                        }
                        break;
                    case "pulse_oximetry":
                        if ((num && value >= 1 && value <= 100) || value === "") {
                            updatedState.pulse_oximetry = value;
                            if(value === ""){
                                updatedState.oxygen_support = "";
                                updatedState.oxygen_source = "";
                            }
                        }
                        break;
                    case "pulse_rate":
                        if ((num && value >= 1 && value <= 150) || value === "") {
                            updatedState.pulse_rate = value;
                        }
                        break;
                    case "blood_sugar":
                        if ((num && value >= 1 && value <= 500) || value === "") {
                            updatedState.blood_sugar = value;
                        }
                        break;
                    case "head_circumference":
                        if ((num && value >= 1 && value <= 56) || value === "") {
                            updatedState.head_circumference = value;
                        }
                        break;
                    case "waist_circumference":
                        if ((isOnlyNum && value >= 1 && value <= 999) || value === "") {
                            updatedState.waist_circumference = value;
                        }
                        break;
                    case "gestational_age_weeks":
                        if ((num && value >= 1 && value <= 45) || value === "") {
                            const newValue = value.replace(/^0+/, "");
                            updatedState.gestational_age_weeks = newValue.trim();
                            updatedState.GestationalCalculation = !!(newValue || prev.gestational_age_days);
                        }
                        break;
                    case "gestational_age_days":
                        if ((num && value >= 1 && value <= 6) || value === "") {
                            const newValue = value.replace(/^0+/, "");
                            updatedState.gestational_age_days = newValue.trim();
                            updatedState.GestationalCalculation = !!(prev.gestational_age_weeks || newValue);
                        }
                        break;
                    case "oxygen_support":
                        if ((num && value >= 1 && value <= 100) || value === "") {
                            updatedState.oxygen_support = value;
                        }
                        break;
                    default:
                        updatedState[key] = value;
                        break;
                }

                return updatedState;
            });
        } catch (error) {
            console.error(error.message);
        }
    };

    const renderTextField = (label, key, unit, lastPosition = null, color) => {        
        return (
            <Box sx={{ display: "flex", flexDirection: "column", backgroundColor: Colors.white, width: '100%' }}>
                <Box sx={{ width: lastPosition === 2 ? '200%' : '100%', backgroundColor: Colors.Background }}>
                    <Typography sx={{ padding: "1.3vh 1vh 1vh 1vh" }} variant="body2" fontWeight="bold">{label}</Typography>
                </Box> {label === "Capillary Refill Time" ?
                    <TextField
                        size="small"
                        select
                        sx={{ width: "16vw", padding: 0, m: "1vh 1vh 2vh 1vh" }}
                        value={vitalState.capillaryRefillTime}
                        onChange={(e) => onChangeHandler(e, "capillaryRefillTime")}
                        SelectProps={{
                            IconComponent: () => null,
                        }}
                        InputProps={{
                            endAdornment: (

                                <Typography
                                    sx={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: Colors.Background, width: "6vw", height: "3vw", padding: 0 ,color:'black'}} variant="caption">sec</Typography>
                            ),
                            sx: { color, paddingRight: 0, },
                        }}
                    >
                        <MenuItem value="<2">≤2</MenuItem>
                        <MenuItem value=">2-<3">{">2 - <3"}</MenuItem>
                        <MenuItem value=">3">≥3</MenuItem>
                    </TextField> : (label !== "BMI" && label !== "BSA" && <TextField
                        size="small"
                        sx={{ width: "16vw", padding: 0, m: "1vh 1vh 2vh 1vh" }}
                        value={vitalState[key]}
                        onChange={(e) => onChangeHandler(e, key)}
                        inputProps={{ maxLength: label === "Comments" ? 100 : null, style: { color: color, fontWeight: '600' } }}
                        InputProps={{
                            endAdornment: (label === 'Temperature' ?
                                <FormControl size='small'>
                                    <Select
                                        // sx={{ width: '4.1vw', height: "6.2vh", mr: "2vw" }}
                                        size='small'
                                        sx={{ width: '4.1vw', mr: "2vw" }}
                                        variant='outlined'
                                        value={vitalState.tempUnit}
                                        onChange={(e) => setVitalState((prev) => ({ ...prev, tempUnit: e.target.value }))}
                                    >
                                        <MenuItem value={'F'}>{'°F'}</MenuItem>
                                        <MenuItem value={'C'}>{'°C'}</MenuItem>
                                    </Select>
                                </FormControl>
                                : label === 'Comments' ? null : <Typography sx={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: Colors.Background, width: "6vw", height: "3vw", padding: 0 }} variant="caption">{unit}</Typography>
                            ),
                            sx: {
                                paddingRight: 0,
                            },
                        }}
                    />)

                }
                   

                {(vitalState.height_cm && vitalState.weight_kg) && (label === 'BMI') ?
                    <Box component={'div'}
                        sx={{ backgroundColor: vitalState.bmi < 18.5 ? '#FFCCCB' : ((vitalState.bmi >= 18.5) && (vitalState.bmi <= 25)) ? 'lightgreen' : ((vitalState.bmi > 25) && (vitalState.bmi <= 30)) ? '#FBB917' : '#FF6863', width: "16.95vw", marginTop: "0.625vw" }}
                        display={'flex'} borderRadius={'5px'} mb={'0.5vw'} p={'0vw 0.5vw'} justifyContent={'space-between'} alignItems={'center'} height={'2.5vw'}>
                        <Typography fontWeight={600} fontSize={'0.9vw'}>BMI</Typography>
                        <FormHelperText>
                            <Typography fontWeight={600} fontSize={'0.8vw'}>{bmiHelperText(vitalState.bmi)}</Typography>
                        </FormHelperText>
                        <Typography fontWeight={600} fontSize={'0.9vw'}>{vitalState.bmi}</Typography>
                    </Box> : null}
                {(vitalState.height_cm && vitalState.weight_kg) && (label === 'BSA') ?
                    <Box component={'div'}
                        sx={{ backgroundColor: ((vitalState.bsa >= 1.4) && (vitalState.bsa <= 2.4)) ? 'lightgreen' : ((vitalState.bsa < 1.4)) ? '#FBB917' : '#FF6863', width: "16.95vw", marginTop: "0.625vw" }}
                        display={'flex'} borderRadius={'5px'} mb={'0.5vw'} p={'0vw 0.5vw'} justifyContent={'space-between'} alignItems={'center'} height={'2.5vw'}>
                        <Typography fontWeight={600} fontSize={'0.9vw'}>BSA</Typography>
                        <FormHelperText>
                            <Typography fontWeight={600} fontSize={'0.8vw'}>{bsaHelperText(vitalState.bsa)}</Typography>
                        </FormHelperText>
                        <Typography fontWeight={600} fontSize={'0.9vw'}>{vitalState.bsa}</Typography>
                    </Box> : null}
            </Box>
        )

    }

    const renderSelect = (label, stateKey, list = [], isDisable = false, lastPosition = null, showKey = "label", valueKey = "value") => {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", backgroundColor: Colors.white, width: '100%' }}>
                <Box sx={{ width: lastPosition === 2 ? '200%' : '100%', backgroundColor: Colors.Background }}>
                    <Typography sx={{ padding: "1.3vh 1vh 1vh 1vh" }} variant="body2" fontWeight="bold">{label}</Typography>
                </Box>
                <Select
                    sx={{ width: "16vw", padding: 0, m: "1vh 1vh 2vh 1vh", fontSize: '0.95vw' }}
                    size='small'
                    value={vitalState[stateKey]}
                    onChange={(e) => { setVitalState((prev) => ({ ...prev, [stateKey]: e.target.value, oxygen_support: "" })) }}
                    disabled={isDisable}
                >
                    {list?.map((item) => (
                        <MenuItem sx={{ fontSize: '0.95vw' }} key={item[valueKey]} value={item[valueKey]}>{item[showKey]}</MenuItem>
                    ))}
                </Select>
            </Box>
        )
    }

    const VitalDateTimePicker = (label, key, value, lastPosition = null) => {
        return (
            <Box    >
                <Typography sx={{ padding: "1.3vh 1vh 1vh 1vh", backgroundColor: Colors.Background, width: lastPosition === 2 ? '200%' : '100%' }} variant="body2" fontWeight="bold">{label}</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                        inputFormat="DD-MM-YYYY & hh:mm A"
                        value={vitalState.vitalDate ? dayjs(vitalState.vitalDate) : null}
                        onChange={(newDate) => {
                            setVitalState(prev => ({
                                ...prev,
                                vitalDate: newDate ? newDate.toDate?.() || new Date(newDate) : new Date()
                            }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                variant="outlined"
                                fullWidth
                                sx={{ width: "16vw", padding: 0, m: "1vh 1vh 2vh 1vh" }}
                            />
                        )}
                    />
                </LocalizationProvider>
            </Box>
        );
    };
    const ObgynDatePicker = (label, key, value, lastPosition = null) => {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", backgroundColor: Colors.white, height: "auto", }}>
                {key === "expected_date_of_delivery" ?
                    <FormControlLabel
                        sx={{ margin: 0, display: "inline-flex", alignItems: "center" }}
                        control={
                            <Checkbox
                                size="small"    
                                sx={{ backgroundColor: Colors.Background, borderRadius: "0vw", margin: 0 }}
                                emed_tid="add_credit_bill"
                                disabled={
                                    vitalState.obs_LastMenstrualPeriod === null &&
                                    vitalState.expected_date_of_delivery === null
                                }
                                checked={vitalState.DeliverydateCalac}
                                onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    setVitalState((prev) => {
                                        const newState = { ...prev, DeliverydateCalac: isChecked };
                                        if (isChecked) {
                                            const edd = new Date(
                                                new Date(prev.obs_LastMenstrualPeriod).getTime() + 40 * 7 * 24 * 60 * 60 * 1000
                                            );
                                            newState.expected_date_of_delivery = edd;
                                        } else {
                                            newState.expected_date_of_delivery = null;
                                        }
                                        return newState;
                                    });
                                }}
                            />
                        }
                        label={
                            <Typography
                                sx={{
                                    height: "5vh",
                                    width: lastPosition === 2 ? "200%" : "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    margin: 0,
                                    backgroundColor: Colors.Background
                                }}
                                variant="body2"
                                fontWeight="bold"
                            >
                                Exp date of delivery
                            </Typography>
                        }
                    /> :
                    <Typography sx={{ padding: "1.3vh 1vh 1vh 1vh", backgroundColor: Colors.Background }} variant="body2" fontWeight="bold">{label || "Exp date of delivery"}</Typography>}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        // value={value ? (value) : null}
                        value={value ? dayjs(value) : null}
                        inputFormat="DD-MM-YYYY"
                        views={["year", "month", "day"]}
                        maxDate={key === "obs_LastMenstrualPeriod" ? (new Date()) : null}
                        minDate={key === "expected_date_of_delivery" || key === "corrected_edd" ? (new Date()) : null}
                        // disabled={disable}
                        onChange={(newDate) => {
                            const jsDate = newDate ? new Date(newDate) : null;

                            setVitalState((prev) => {
                                const updatedState = { ...prev };

                                if (key === "obs_LastMenstrualPeriod" && jsDate) {
                                    updatedState[key] = jsDate;
                                    updatedState["expected_date_of_delivery"] = new Date(jsDate.getTime() + 40 * 7 * 24 * 60 * 60 * 1000);

                                    const { weeks, days } = calculateWeeksAndDays(jsDate, new Date());
                                    updatedState["DeliverydateCalac"] = true;
                                    updatedState["GestationalCalculation"] = true;
                                    updatedState["gestational_age_weeks"] = weeks?.toString();
                                    updatedState["gestational_age_days"] = days?.toString();
                                } else {
                                    if (key === "expected_date_of_delivery") {
                                        updatedState["DeliverydateCalac"] = true;
                                    }
                                    updatedState[key] = jsDate;
                                }

                                return updatedState;
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}

                                sx={{
                                    width: "16vw",
                                    margin: "1vh",
                                    '& .MuiInputBase-root': {
                                        // height: "6.2vh"
                                    },
                                    '& input': {
                                        height: "100%"
                                    }
                                }}
                                autoComplete="off"
                                onKeyDown={(e) => e.preventDefault()}
                                size="small"
                            />
                        )}

                    />
                </LocalizationProvider>
            </Box>
        );
    };

    const renderGestationalTextField = (label, key, unit, lastPosition = null) => {
        return (
            <TextField
                size="small"
                sx={{ width: "8vw", padding: 0, m: "1vh 0vh" }}
                // value={value}
                value={vitalState[key]}
                onChange={(e) => setVitalState((prev) => ({ ...prev, [key]: e.target.value }))}
                InputProps={{
                    endAdornment: (
                        <Typography sx={{ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: Colors.Background, width: lastPosition === 2 ? '200%' : '100%', height: "3vw", padding: 0 }} variant="caption">{unit}</Typography>),
                    sx: {
                        paddingRight: 0,
                    },
                }}
            />)
    }


    const renderGestationAge = (label, stateKey, value, lastPosition = null) => {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", backgroundColor: Colors.white, height: "auto", }}>
                {/* {stateKey === "expected_date_of_delivery" ? <FormControlLabel */}
                <FormControlLabel
                    sx={{ margin: 0, display: "inline-flex", alignItems: "center" }}
                    control={
                        <Checkbox
                            size="small"
                            emed_tid="add_credit_bill"
                            sx={{ backgroundColor: Colors.Background, borderRadius: "0vw", margin: 0 }}
                            disabled={
                                vitalState.obs_LastMenstrualPeriod === null &&
                                vitalState.gestational_weeks === "" &&
                                vitalState.gestational_days === ""
                            }
                            checked={vitalState.GestationalCalculation}
                            onChange={(e) => {
                                const isChecked = e.target.checked;
                                setVitalState((prev) => {
                                    const newState = { ...prev, GestationalCalculation: isChecked };
                                    if (isChecked) {
                                        const { weeks, days } = calculateWeeksAndDays(
                                            new Date(prev.obs_LastMenstrualPeriod),
                                            new Date()
                                        );
                                        newState.gestational_weeks = weeks?.toString();
                                        newState.gestational_days = days?.toString();
                                    } else {
                                        newState.gestational_weeks = "";
                                        newState.gestational_days = "";
                                    }
                                    return newState;
                                });
                            }}
                        />
                    }
                    label={
                        <Typography
                            fontWeight={600}
                            fontSize="0.9dvw"
                            color={Colors.SecondaryText}
                            sx={{ padding: "1.3vh 1vh 1vh 1vh", backgroundColor: Colors.Background, width: lastPosition === 2 ? '200%' : '100%' }}
                        >
                            Gestational Age
                        </Typography>
                    }
                />
                <Box component={'div'} display="flex" alignItems={'center'}>
                    {renderGestationalTextField("Gestational Age", "gestational_age_weeks", "weeks")}
                    {renderGestationalTextField("Gestational Weeks", "gestational_age_days", "Days")}
                </Box>
            </Box>
        );
    };


    const renderNurseSelection = (label, stateKey, value, lastPosition = null) => {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", backgroundColor: Colors.white, }}>
                <Typography sx={{ padding: "1.3vh 1vh 1vh 1vh", backgroundColor: Colors.Background, width: lastPosition === 2 ? '200%' : '100%' }} variant="body2" fontWeight="bold">{label}</Typography>
                <Autocomplete
                    size='small'
                    options={nurseList}
                    getOptionLabel={(option) => option.nurse}
                    value={vitalState.nurse_name}
                    onChange={(event, newValue) => {
                        setVitalState((prev) => ({ ...prev, nurse_name: newValue }))
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            sx={{
                                width: "16vw", m: "1vh 1vh 2vh 1vh", "& .MuiInputBase-root": {
                                    // height: "6vh",
                                }
                            }}
                            inputProps={{ ...params.inputProps, 'emed_tid': 'NurseName', }}
                        />
                    )}
                />
            </Box>
        )

    }

    const renderVitalInput = (item, lastPosition) => {
        let bpsColor = vitalState.blood_pressure_diastolic <= 120 ? "green" : "red"
        let bpdColor = vitalState.blood_pressure_systolic <= 80 ? "green" : "red"
        let tempColor = ((vitalState.tempUnit === 'F' && (vitalState.temperature >= 97 && vitalState.temperature <= 99)) || (vitalState.tempUnit === 'C' && (vitalState.temperature >= 36.1 && vitalState.temperature <= 37.2))) ? 'green' : 'red'
        let spo2Color = (vitalState.pulse_oximetry >= 95 && vitalState.pulse_oximetry <= 100) ? "green" : "red"
        let rateColor = (vitalState.pulse_rate >= 60 && vitalState.pulse_rate) ? 'green' : 'red'
        let bloodColor = vitalState.blood_sugar <= 200 ? 'green' : 'red'
        let heartRateColor = vitalState.heartRate >= 60 && vitalState.heartRate <= 100 ? "green" : "red"
        let respiratoryRateColor = vitalState.respiratoryRate >= 12 && vitalState.respiratoryRate <= 20 ? "green" : "red"
        let capillaryColor = vitalState.capillaryRefillTime === "<2" ? "green" : vitalState.capillaryRefillTime === ">2-<3" ? "orange" : vitalState.capillaryRefillTime === ">3" ? "red" : ""

        switch (item?.field_name) {
            case 'height':
                return renderTextField("Height", "height_cm", "Cm", lastPosition);
            case 'weight':
                return renderTextField("Weight", "weight_kg", "kg", lastPosition);
            case 'bpsystolic':
                return renderTextField("Systolic BP", "blood_pressure_systolic", "mm/Hg", lastPosition, bpsColor);
            case 'heart_rate':
                return renderTextField("Heart Rate", "heartRate", "bpm", lastPosition, heartRateColor);
            case 'respiratory_rate':
                return renderTextField("Respiratory Rate", "respiratoryRate", "breaths/min", lastPosition, respiratoryRateColor);
            case 'capillary_refill_time':
                return renderTextField("Capillary Refill Time", "capillaryRefillTime", "", lastPosition, capillaryColor);
            case 'bpdistolic':
                return renderTextField("Diastolic BP", "blood_pressure_diastolic", "mm/Hg", lastPosition, bpdColor);
            case 'temp':
                return renderTextField("Temperature", "temperature", "", lastPosition, tempColor);
            case 'spo2':
                return renderTextField("Pulse Oximetry", "pulse_oximetry", "%", lastPosition, spo2Color);
            case 'pulse':
                return renderTextField("Pulse Rate", "pulse_rate", "/min", lastPosition, rateColor);
            case 'blood_glucose':
                return renderTextField("Random Blood Glucose", "blood_sugar", "mg/dL", lastPosition, bloodColor);
            case 'waist_circumference':
                return renderTextField("Waist Circumference", "waist_circumference", "Cm", lastPosition);
            case 'head_circumference':
                return renderTextField("Head Circumference", "head_circumference", "Cm", lastPosition);
            case 'comments':
                return renderTextField("Comments", "comments", "", lastPosition);
            case 'expected_date_of_delivery':
                return ObgynDatePicker("Expected Date of Delivery", "expected_date_of_delivery", vitalState["expected_date_of_delivery"], lastPosition);
            case 'last_mensural':
                return ObgynDatePicker("Last Menstrual Period", "obs_LastMenstrualPeriod", vitalState["obs_LastMenstrualPeriod"], lastPosition);
            case 'corrected_edd':
                return ObgynDatePicker("Corrected EDD", "corrected_edd", vitalState["corrected_edd"], lastPosition);
            case 'vital_entered_time':
                return VitalDateTimePicker("Vital Date", "vital_entered_time", "", lastPosition);
            case 'gestational_age':
                return renderGestationAge("Gestational Age", "gestational_age_days", "", lastPosition);
            case 'nurse_name':
                return renderNurseSelection("Nurse Name", "nurse_name", "", lastPosition);
            case 'bmi':
                return renderTextField("BMI", "bmi", "", lastPosition);
            case 'bsa':
                return renderTextField("BSA", "bsa", "", lastPosition);
            case 'oxygensource':
                const oxygenSourceComponent = renderSelect("Oxygen Source", "oxygen_source", oxygen_source_list, !vitalState.pulse_oximetry, lastPosition);
                const oxygenSupportComponent = vitalState.oxygen_source === "O2 (With Oxygen)" ? renderTextField("Oxygen Support", "oxygen_support", "L/min", lastPosition) : null;
                return [oxygenSourceComponent, oxygenSupportComponent].filter(Boolean);
            default:
                return null;
        }
    };

    return (
        <ShowComponents onIntersection={getApiCall.bind(this)}>
            <Card sx={{
                width: "100%", height: "fit-content", padding: "0.3vw",
                marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
            }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
                    <Typography fontSize={'1vw'} fontWeight={600} color={Colors.SecondaryText}> {renderTitle(Title, props.isSelected)}</Typography>
                    <Stack direction="column" sx={{ height: "7vh" }} alignItems="center" justifyContent="center">
                        <Stack direction="row" spacing={2} display={"flex"} justifyContent='center' alignItems="center" mt='0.3vh'>
                            <ActionButton text={"Clear"} emed_tid='doc_notes_bold_clr' disabled={postLoading || props.isLocked} variant={'outlined'} onClick={onClearHandler} />
                            <ActionButton text={"Save"} emed_tid='doc_notes_bold_clr' disabled={postLoading || props.isLocked} onClick={postDoctorNotesVitalData} />
                        </Stack>
                    </Stack>
                </Box>
                <Box sx={{ height: "20vw", overflowY: "auto", overflowX: "hidden" }}>
                <Grid container>
                    {vitalLayout.map((item, i) => {
                        if (!item.is_active) return null;
                        const isLast = i === vitalLayout.length - 1;
                        const lastPosition = isLast ? ((i + 1) % 3) : 0;

                        const inputComponent = renderVitalInput(item, lastPosition);
                        const componentsArray = (Array.isArray(inputComponent) ? inputComponent : [inputComponent]).filter(Boolean);
                        // skip rendering if no valid component
                        if (componentsArray.length === 0) return null;

                        return componentsArray.map((comp, index) => (
                            <Grid item xs={12} md={4} xl={4} key={`${i}-${index}`}>
                                {comp}
                            </Grid>
                        ));
                    })}
                </Grid>
                </Box>
            </Card>
        </ShowComponents>
    );
};

export default SarasVitals;